import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../context/UserContext'
import { Form, Col,  } from 'react-bootstrap'
import { Dropdown } from 'primereact/dropdown'
import css from '../AnuncioForm.module.css'
import { linkApi } from '../../config'

export default function Models({ values, setFieldValue }) {
    const { user } = useContext(UserContext)
    const [models, setModels] = useState([{ id: '0', name: 'Nada' }])

    const handleDropdownChange = (e) => {
        setFieldValue('model.id', e.target.value)
        setFieldValue('registration.year', '')
        setFieldValue('fuel.id', '')
        setFieldValue('segment.id', '')
        setFieldValue('engine.power_cv', '')
        setFieldValue('version.id', '')
    }

    useEffect(() => {
        let id = values.make.id

        const postData = async () => {
            const options = {
                method: 'GET',
                headers: {
                    authorization: 'Bearer ' + user.token,
                },
            }

            const res = await fetch(`${linkApi}/v1/cars/models/${id}`, options)
                .then((response) => response.json())
                .catch((err) => console.error(err))

            const res2 = res.data.sort((b, a) => b.name.localeCompare(a.name))
            // console.log('Modelos e Modelos', res2)
            setModels(res2)
        }
        id && postData()
    }, [user.token, values.make.id])

    return (
        <div>
            <Form.Group as={Col} controlId="validationFormik03">
                <Form.Label className={css.label}>Modelos</Form.Label>
                <Dropdown
                    value={values.model.id}
                    onChange={handleDropdownChange}
                    options={models}
                    placeholder="Escolher Modelo"
                    optionLabel="name"
                    optionValue="id"
                    filter
                    // disabled
                    className="w-full md:w-14rem"
                    style={{ width: '-webkit-fill-available' }}
                />
            </Form.Group>
        </div>
    )
}
